import { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import styled from "styled-components";
import Header from "./components/Header";
import Filters from "./components/Filters";
import CreateEditModal from "./components/CreateEditModal";
import DeleteModal from "./components/DeleteModal";
import OperacoesModal from "./components/OperacoesModal";
import DatatableAntd from "components/datatable-antd";
import columns from "./components/columns";
import useGetClasses from "./hooks/useGetClasses";

function ClassesOperacao() {
  const [filters, setFilters] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const { data, isLoading, refetch } = useGetClasses(page, pageSize, filters);

  useEffect(() => {
    if (data) {
      setTotal(data?.paginate?.totalCount);
    }
  }, [data]);

  return (
    <Flex flex={1} bgColor="white" flexDir={"column"}>
      <CreateEditModal refetch={refetch} />

      <DeleteModal refetch={refetch} />

      <OperacoesModal />

      <Header />

      <Filters data={data?.data} handleFilter={setFilters} />

      <Counter>
        <b>Classes Cadastradas</b>
        <p>{data?.data.length ?? 0} Classes</p>
      </Counter>

      <RoundedTable
        style={{ margin: 16 }}
        columns={columns}
        loading={isLoading}
        dataSource={data?.data}
        pagination={{
          total,
          pageSize,
          current: page,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />
    </Flex>
  );
}

const Counter = styled.div`
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  border: 1px solid #e2e8f0;
  padding: 18px;
  border-radius: 8px;

  p {
    color: #fff;
    font-weight: bold;
    background-color: #12619c;
    padding: 4px 12px;
    border-radius: 15px;
  }
`;

const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }
`;

export default ClassesOperacao;
